<template>
    <div>

        <b-card class="border-silver p-1">
            <p>{{packageItem.title}}</p>
            <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center px-0">
                    show/hide
                    <span>{{ (isServer ? packageItem.formatShow : packageItem.is_hide) }}</span>
                </b-list-group-item>
            </b-list-group>
            <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center px-0">
                    Show for this product?
                    <span>{{ (isServer ? packageItem.isCustomTitle : packageItem.is_custom_title) }}</span>
                </b-list-group-item>
            </b-list-group>
            <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center px-0">
                    count decrement
                    <span>{{packageItem.count}}</span>
                </b-list-group-item>
            </b-list-group>
            <b-list-group v-if="isServer && packageItem.isCustomTitle.match('yes')">
                <b-list-group-item class="d-flex justify-content-between align-items-center px-0">
                    product
                    <span>{{packageItem.product}}</span>
                </b-list-group-item>
            </b-list-group>

            <template v-if="isServer">
                <b-button variant="danger" @click="removePackageItemServer(packageItem.id)">delete</b-button>
                <b-button variant="info" @click="editPackage(packageItem)">edit</b-button>

            </template>
            <template v-else>
                <b-button variant="danger" @click="removePackageItem(packageItem.id)">delete</b-button>
            </template>

            <span class="mr-3 handle float-right">
                                    <span class="material-icons">drag_handle</span>
                                </span>
        </b-card>
    </div>
</template>

<script>
    import Http from '../../../Services/HttpService/HttpService'
    import Notification from '../../../Services/Notification/Nottification'
    import {EventBus} from "../../../Services/Eventbus/event-bus";

    export default {
        name: "Package",
        props: {
            packages: {
                type: Array,
                default: null
            },
            packageItem: {
                type: Object,
                default: null
            },
            isServer: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            removePackageItem(id) {
                let item = this.packages.find(item => item.id === id);
                if (item) {
                    this.packages.splice(this.packages.indexOf(item), 1);
                }
            },
            removePackageItemServer(id) {
                if (confirm(this.$t('alertText'))) {
                    this.$Progress.start();
                    Http.get(Http.apiurlV2() + 'product/package/delete/' + id)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                EventBus.$emit('updatePackage', 'yes');
                                Notification.success(response.data.message)
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }
            },
            editPackage(item) {
                EventBus.$emit('updatePackageItem', item)
            },
        },
    }
</script>

<style scoped>

</style>